import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=b8e5ca24&scoped=true"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"
import style0 from "./TestComponent.vue?vue&type=style&index=0&id=b8e5ca24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e5ca24",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TestComponent.vue
// module id = 63
// module chunks = 0